import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

import MenuItem from './MenuItem';

const MenuContainer = styled.div`
  width: ${({ width, isFullWidth }) => (isFullWidth ? `100%` : `${width}px`)};
  background-color: ${theme.colors.white};
  display: ${({ isVisible }) => (isVisible ? `block` : `none`)};
  padding: ${theme.spacing.xs} 0;
  border-radius: ${theme.surface.borderRadius};
  box-shadow: ${theme.surface.boxShadow};
  animation: growDown 200ms ease-in-out forwards;
  transform-origin: top center;

  @keyframes growDown {
    0% {
      transform: scaleY(0);
    }
    80% {
      transform: scaleY(1.1);
    }
    100% {
      transform: scaleY(1);
    }
  }
`;

const Menu = ({ children, width, isFullWidth, isVisible, ...props }) => {
  const menuItems = React.Children.toArray(children).filter((element) => {
    if (React.isValidElement(element)) {
      return true;
    }

    console.warn('메뉴 아이템만 자식 요소로 들어올 수 있습니다.');
    return false;
  });

  return (
    <MenuContainer
      width={width}
      isFullWidth={isFullWidth}
      isVisible={isVisible}
      style={{ ...props.style }}
    >
      {menuItems}
    </MenuContainer>
  );
};

Menu.Item = MenuItem;

Menu.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.number,
  isFullWidth: PropTypes.bool,
  isVisible: PropTypes.bool,
  style: PropTypes.object,
};

Menu.defaultProps = {
  width: 184,
  isFullWidth: false,
  isVisible: true,
  style: {},
};

export default Menu;
